import { array } from 'fp-ts';
import { LocalizedMarkdown } from '@mews-distributor/common';
import { LocalizedPropertyObject, LocalizedText } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { RecaptchaBranding } from './RecaptchaBranding';

interface LegalStatementsProps {
    statements: LocalizedPropertyObject[];
    textKeyStatements: Mews.TextKey[];
}

export const LegalStatements = ({ statements, textKeyStatements }: LegalStatementsProps) => {
    const recaptchaBranding = <RecaptchaBranding />;

    if (array.isEmpty(statements) && array.isEmpty(textKeyStatements) && recaptchaBranding == null) {
        return null;
    }

    return (
        <Stack spacing="100" vertical>
            {recaptchaBranding}
            {textKeyStatements.map((textKey) => (
                <Typography textStyle="bodySmall" variant="secondary" align="center" key={textKey} as="div">
                    <LocalizedText textKey={textKey} />
                </Typography>
            ))}
            {statements.map((s, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Typography textStyle="bodySmall" variant="secondary" align="center" key={index} as="div">
                    {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                    <LocalizedMarkdown property={s} />
                </Typography>
            ))}
        </Stack>
    );
};
